import extractDataFromFirebaseCredential from 'lib/extractDataFromFirebaseCredential';

import { AuthUser } from 'types/User';
import { authAndSignInWithProvider, AuthProviders } from 'lib/Auth';

export default async function signInWithGoogle(): Promise<AuthUser> {
  const credential = await authAndSignInWithProvider(AuthProviders.Google);
  return extractDataFromFirebaseCredential(credential);
}
